// src/frontend/react-js/data/mock.js

import sampleImg from './222.jpg';
import samplePC from './pc1.png';
import cs2 from './cs2.jpg';
import cod from './cod.png';
import cp from './cp.jpg';
import fn from './fn.png';

export const configuratorData = {
    cpu: [
        { id: 'cpu-0', name: 'Intel Core Ultra 7 265K', price: 420, socket: 'LGA1851', power: 125, image: sampleImg },
        { id: 'cpu-1', name: 'Intel Core Ultra 5 245K', price: 310, socket: 'LGA1851', power: 125, image: sampleImg },
        { id: 'cpu-2', name: 'Intel Core Ultra 9 285K', price: 630, socket: 'LGA1851', power: 125, image: sampleImg },
        { id: 'cpu-3', name: 'Intel Core Ultra 5 225H', price: 280, socket: 'LGA1851', power: 65, image: sampleImg },
        { id: 'cpu-4', name: 'AMD Ryzen 9 9950X', price: 650, socket: 'AM5', power: 170, image: sampleImg },
        { id: 'cpu-5', name: 'AMD Ryzen 9 9900X', price: 500, socket: 'AM5', power: 120, image: sampleImg },
        { id: 'cpu-6', name: 'AMD Ryzen 7 9700X', price: 360, socket: 'AM5', power: 65, image: sampleImg },
        { id: 'cpu-7', name: 'AMD Ryzen 5 9600X', price: 280, socket: 'AM5', power: 65, image: sampleImg },
    ],
    gpu: [
        { id: 'gpu-0', name: 'NVIDIA RTX 3060', price: 280, power: 170, fpsIndex: 0, image: sampleImg },
        { id: 'gpu-1', name: 'AMD Radeon RX 6700 XT', price: 330, power: 230, fpsIndex: 1, image: sampleImg },
        { id: 'gpu-3', name: 'NVIDIA RTX 4070', price: 600, power: 200, fpsIndex: 2, image: sampleImg },
        { id: 'gpu-4', name: 'NVIDIA RTX 4090', price: 1600, power: 450, fpsIndex: 3, image: sampleImg },
        { id: 'gpu-5', name: 'AMD Radeon RX 7600', price: 260, power: 165, fpsIndex: 0, image: sampleImg },
        { id: 'gpu-6', name: 'NVIDIA RTX 4080 Super', price: 1000, power: 320, fpsIndex: 3, image: sampleImg },
    ],
    motherboard: [
        { id: 'mb-0', name: 'ASUS ROG CROSSHAIR X870E HERO', price: 650, socket: 'AM5', image: sampleImg },
        { id: 'mb-1', name: 'ASUS TUF GAMING B650-PLUS WIFI', price: 210, socket: 'AM5', image: sampleImg },
        { id: 'mb-2', name: 'MSI MAG X870 TOMAHAWK WIFI', price: 330, socket: 'AM5', image: sampleImg },
        { id: 'mb-3', name: 'Gigabyte X870E AORUS MASTER', price: 500, socket: 'AM5', image: sampleImg },
        { id: 'mb-4', name: 'ASRock X870 Steel Legend WIFI', price: 300, socket: 'AM5', image: sampleImg },
        { id: 'mb-5', name: 'ASUS ROG MAXIMUS Z890 EXTREME', price: 750, socket: 'LGA1851', image: sampleImg },
        { id: 'mb-6', name: 'ASUS PRIME Z890-P WIFI', price: 280, socket: 'LGA1851', image: sampleImg },
        { id: 'mb-7', name: 'MSI PRO Z890-A WIFI', price: 260, socket: 'LGA1851', image: sampleImg },
        { id: 'mb-8', name: 'Gigabyte Z890 AORUS PRO X', price: 350, socket: 'LGA1851', image: sampleImg },
        { id: 'mb-9', name: 'ASRock Z890 LiveMixer WIFI', price: 250, socket: 'LGA1851', image: sampleImg },
    ],
    ram: [
        { id: 'ram-0', name: '16GB (2x8GB) DDR4-3200', price: 40, image: sampleImg },
        { id: 'ram-1', name: '32GB (2x16GB) DDR4-3600', price: 70, image: sampleImg },
        { id: 'ram-2', name: '32GB (2x16GB) DDR5-6000', price: 110, image: sampleImg },
        { id: 'ram-3', name: '64GB (2x32GB) DDR5-6000', price: 200, image: sampleImg },
    ],
    storage: [
        { id: 'ssd-0', name: '500GB NVMe SSD (Gen3)', price: 35, image: sampleImg },
        { id: 'ssd-1', name: '1TB NVMe SSD (Gen4)', price: 65, image: sampleImg },
        { id: 'ssd-2', name: '2TB NVMe SSD (Gen4)', price: 120, image: sampleImg },
        { id: 'ssd-3', name: '4TB NVMe SSD (Gen4)', price: 250, image: sampleImg },
    ],
    storage2: [
        { id: 'ssd-0', name: '500GB NVMe SSD (Gen3)', price: 35, image: sampleImg },
        { id: 'ssd-1', name: '1TB NVMe SSD (Gen4)', price: 65, image: sampleImg },
        { id: 'ssd-2', name: '2TB NVMe SSD (Gen4)', price: 120, image: sampleImg },
        { id: 'ssd-3', name: '4TB NVMe SSD (Gen4)', price: 250, image: sampleImg },
    ],
    psu: [
        { id: 'psu-0', name: '550W 80+ Bronze', price: 50, wattage: 550, image: sampleImg },
        { id: 'psu-1', name: '650W 80+ Gold', price: 80, wattage: 650, image: sampleImg },
        { id: 'psu-2', name: '850W 80+ Gold', price: 120, wattage: 850, image: sampleImg },
        { id: 'psu-3', name: '1000W 80+ Gold', price: 160, wattage: 1000, image: sampleImg },
    ],
    case: [
        { id: 'case-1', name: 'beQuiet PURE BASE 600', price: 60, image: sampleImg },
        { id: 'case-2', name: 'Phanteks XT Pro Ultra', price: 70, image: sampleImg },
        { id: 'case-3', name: 'Lian Li V100', price: 80, image: sampleImg },
        { id: 'case-4', name: 'Lian Li V100', price: 80, image: sampleImg },
        { id: 'case-5', name: 'Lian Li A3', price: 85, image: sampleImg },
        { id: 'case-6', name: 'Corsair Frame 4000D RS ARGB', price: 115, image: sampleImg },
        { id: 'case-7', name: 'Corsair Frame 4000D RS ARGB', price: 115, image: sampleImg },
        { id: 'case-8', name: 'Fractal Design North Mesh', price: 125, image: sampleImg },
        { id: 'case-9', name: 'NZXT H6 RGB+', price: 200, image: sampleImg },
        { id: 'case-10', name: 'NZXT H6 RGB+', price: 200, image: sampleImg },
        { id: 'case-11', name: 'Lian Li O11 Dynamic EVO RGB', price: 150, image: sampleImg },
        { id: 'case-12', name: 'Lian Li O11 Dynamic EVO RGB', price: 150, image: sampleImg },
],
    cooling: [
        { id: 'air-0', name: 'Intel/AMD Boxed Kühler', price: 0, image: sampleImg },
        { id: 'air-1', name: 'Thermalright Assassin X 120', price: 20, image: sampleImg },
        { id: 'air-2', name: 'Be Quiet! Dark Rock 4', price: 65, image: sampleImg },
        { id: 'air-3', name: 'NZXT Kraken 240 (AiO)', price: 130, image: sampleImg },
        { id: 'air-4', name: 'Arctic Liquid Freezer II 360', price: 110, image: sampleImg },
        { id: 'aio-0', name: 'Intel/AMD Boxed Kühler', price: 0, image: sampleImg },
        { id: 'aio-1', name: 'Thermalright Assassin X 120', price: 20, image: sampleImg },
        { id: 'aio-2', name: 'Be Quiet! Dark Rock 4', price: 65, image: sampleImg },
        { id: 'aio-3', name: 'NZXT Kraken 240 (AiO)', price: 130, image: sampleImg },
        { id: 'aio-4', name: 'Arctic Liquid Freezer II 360', price: 110, image: sampleImg },
    ],
    fans: [
        { id: 'fan-0', name: 'Intel/AMD Boxed Kühler', price: 0, image: sampleImg },
        { id: 'fan-1', name: 'Thermalright Assassin X 120', price: 20, image: sampleImg },
        { id: 'fan-2', name: 'Be Quiet! Dark Rock 4', price: 65, image: sampleImg },
        { id: 'fan-3', name: 'NZXT Kraken 240 (AiO)', price: 130, image: sampleImg },
        { id: 'fan-4', name: 'Arctic Liquid Freezer II 360', price: 110, image: sampleImg },
    ],
    os: [
        { id: 'os-0', name: 'Ohne Betriebssystem', price: 0, image: sampleImg },
        { id: 'os-1', name: 'Windows 11 Home (vorinstalliert)', price: 110, image: sampleImg },
        { id: 'os-2', name: 'Windows 11 Pro (vorinstalliert)', price: 150, image: sampleImg },
    ]
};

export const gpuFpsTable = {
  '1080p': [
    // Index 0: RTX 5050
    [
      { game: 'Cyberpunk 2077', fps: 65, maxFps: 240, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 115, maxFps: 360, logo: cod },
      { game: 'Fortnite', fps: 165, maxFps: 550, logo: fn },
      { game: 'CounterStrike 2', fps: 260, maxFps: 950, logo: cs2 },
    ],
    // Index 1: RTX 5060
    [
      { game: 'Cyberpunk 2077', fps: 85, maxFps: 240, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 140, maxFps: 360, logo: cod },
      { game: 'Fortnite', fps: 210, maxFps: 550, logo: fn },
      { game: 'CounterStrike 2', fps: 340, maxFps: 950, logo: cs2 },
    ],
    // Index 2: RTX 5060 Ti 8GB / RX 9060 XT 8GB
    [
      { game: 'Cyberpunk 2077', fps: 105, maxFps: 240, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 165, maxFps: 360, logo: cod },
      { game: 'Fortnite', fps: 250, maxFps: 550, logo: fn },
      { game: 'CounterStrike 2', fps: 420, maxFps: 950, logo: cs2 },
    ],
    // Index 3: RTX 5060 Ti 16GB / RX 9060 XT 16GB
    [
      { game: 'Cyberpunk 2077', fps: 110, maxFps: 240, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 175, maxFps: 360, logo: cod },
      { game: 'Fortnite', fps: 265, maxFps: 550, logo: fn },
      { game: 'CounterStrike 2', fps: 440, maxFps: 950, logo: cs2 },
    ],
    // Index 4: RTX 5070 / RX 9070
    [
      { game: 'Cyberpunk 2077', fps: 145, maxFps: 240, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 210, maxFps: 360, logo: cod },
      { game: 'Fortnite', fps: 320, maxFps: 550, logo: fn },
      { game: 'CounterStrike 2', fps: 580, maxFps: 950, logo: cs2 },
    ],
    // Index 5: RTX 5070 Ti / RX 9070 XT
    [
      { game: 'Cyberpunk 2077', fps: 170, maxFps: 240, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 250, maxFps: 360, logo: cod },
      { game: 'Fortnite', fps: 380, maxFps: 550, logo: fn },
      { game: 'CounterStrike 2', fps: 680, maxFps: 950, logo: cs2 },
    ],
    // Index 6: RTX 5080
    [
      { game: 'Cyberpunk 2077', fps: 200, maxFps: 240, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 290, maxFps: 360, logo: cod },
      { game: 'Fortnite', fps: 450, maxFps: 550, logo: fn },
      { game: 'CounterStrike 2', fps: 800, maxFps: 950, logo: cs2 },
    ],
    // Index 7: RTX 5090
    [
      { game: 'Cyberpunk 2077', fps: 235, maxFps: 240, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 340, maxFps: 360, logo: cod },
      { game: 'Fortnite', fps: 520, maxFps: 550, logo: fn },
      { game: 'CounterStrike 2', fps: 950, maxFps: 950, logo: cs2 },
    ],
  ],
  '1440p': [
    // Index 0
    [
      { game: 'Cyberpunk 2077', fps: 40, maxFps: 200, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 75, maxFps: 300, logo: cod },
      { game: 'Fortnite', fps: 105, maxFps: 450, logo: fn },
      { game: 'CounterStrike 2', fps: 170, maxFps: 750, logo: cs2 },
    ],
    // Index 1
    [
      { game: 'Cyberpunk 2077', fps: 55, maxFps: 200, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 95, maxFps: 300, logo: cod },
      { game: 'Fortnite', fps: 135, maxFps: 450, logo: fn },
      { game: 'CounterStrike 2', fps: 220, maxFps: 750, logo: cs2 },
    ],
    // Index 2
    [
      { game: 'Cyberpunk 2077', fps: 70, maxFps: 200, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 115, maxFps: 300, logo: cod },
      { game: 'Fortnite', fps: 165, maxFps: 450, logo: fn },
      { game: 'CounterStrike 2', fps: 280, maxFps: 750, logo: cs2 },
    ],
    // Index 3
    [
      { game: 'Cyberpunk 2077', fps: 75, maxFps: 200, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 125, maxFps: 300, logo: cod },
      { game: 'Fortnite', fps: 175, maxFps: 450, logo: fn },
      { game: 'CounterStrike 2', fps: 300, maxFps: 750, logo: cs2 },
    ],
    // Index 4
    [
      { game: 'Cyberpunk 2077', fps: 105, maxFps: 200, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 160, maxFps: 300, logo: cod },
      { game: 'Fortnite', fps: 230, maxFps: 450, logo: fn },
      { game: 'CounterStrike 2', fps: 400, maxFps: 750, logo: cs2 },
    ],
    // Index 5
    [
      { game: 'Cyberpunk 2077', fps: 125, maxFps: 200, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 195, maxFps: 300, logo: cod },
      { game: 'Fortnite', fps: 280, maxFps: 450, logo: fn },
      { game: 'CounterStrike 2', fps: 480, maxFps: 750, logo: cs2 },
    ],
    // Index 6
    [
      { game: 'Cyberpunk 2077', fps: 155, maxFps: 200, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 240, maxFps: 300, logo: cod },
      { game: 'Fortnite', fps: 350, maxFps: 450, logo: fn },
      { game: 'CounterStrike 2', fps: 600, maxFps: 750, logo: cs2 },
    ],
    // Index 7
    [
      { game: 'Cyberpunk 2077', fps: 195, maxFps: 200, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 300, maxFps: 300, logo: cod },
      { game: 'Fortnite', fps: 450, maxFps: 450, logo: fn },
      { game: 'CounterStrike 2', fps: 750, maxFps: 750, logo: cs2 },
    ],
  ],
  '4K': [
    // Index 0
    [
      { game: 'Cyberpunk 2077', fps: 20, maxFps: 130, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 40, maxFps: 200, logo: cod },
      { game: 'Fortnite', fps: 50, maxFps: 270, logo: fn },
      { game: 'CounterStrike 2', fps: 85, maxFps: 480, logo: cs2 },
    ],
    // Index 1
    [
      { game: 'Cyberpunk 2077', fps: 25, maxFps: 130, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 50, maxFps: 200, logo: cod },
      { game: 'Fortnite', fps: 65, maxFps: 270, logo: fn },
      { game: 'CounterStrike 2', fps: 110, maxFps: 480, logo: cs2 },
    ],
    // Index 2
    [
      { game: 'Cyberpunk 2077', fps: 35, maxFps: 130, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 65, maxFps: 200, logo: cod },
      { game: 'Fortnite', fps: 85, maxFps: 270, logo: fn },
      { game: 'CounterStrike 2', fps: 145, maxFps: 480, logo: cs2 },
    ],
    // Index 3
    [
      { game: 'Cyberpunk 2077', fps: 40, maxFps: 130, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 70, maxFps: 200, logo: cod },
      { game: 'Fortnite', fps: 95, maxFps: 270, logo: fn },
      { game: 'CounterStrike 2', fps: 160, maxFps: 480, logo: cs2 },
    ],
    // Index 4
    [
      { game: 'Cyberpunk 2077', fps: 60, maxFps: 130, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 95, maxFps: 200, logo: cod },
      { game: 'Fortnite', fps: 125, maxFps: 270, logo: fn },
      { game: 'CounterStrike 2', fps: 220, maxFps: 480, logo: cs2 },
    ],
    // Index 5
    [
      { game: 'Cyberpunk 2077', fps: 75, maxFps: 130, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 115, maxFps: 200, logo: cod },
      { game: 'Fortnite', fps: 155, maxFps: 270, logo: fn },
      { game: 'CounterStrike 2', fps: 270, maxFps: 480, logo: cs2 },
    ],
    // Index 6
    [
      { game: 'Cyberpunk 2077', fps: 95, maxFps: 130, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 155, maxFps: 200, logo: cod },
      { game: 'Fortnite', fps: 200, maxFps: 270, logo: fn },
      { game: 'CounterStrike 2', fps: 350, maxFps: 480, logo: cs2 },
    ],
    // Index 7
    [
      { game: 'Cyberpunk 2077', fps: 125, maxFps: 130, logo: cp },
      { game: 'Call of Duty: Warzone', fps: 200, maxFps: 200, logo: cod },
      { game: 'Fortnite', fps: 270, maxFps: 270, logo: fn },
      { game: 'CounterStrike 2', fps: 480, maxFps: 480, logo: cs2 },
    ],
  ]
};